import { Grid } from '@material-ui/core';
import React  from 'react';
import PropTypes from 'prop-types';
import SyncIcon from '@material-ui/icons/Sync';
import Button from '../../../buttons/components/Button';

const SyncCrmCustomerWithDatev = ({onSyncCustomerData, isSyncingCustomerData}) => {

    return (
        <Grid container>
            <Grid item>
                    <Button
                        startIcon={<SyncIcon />}
                        disabled={false}
                        color="primary"
                        variant="contained"
                        onClick={onSyncCustomerData}
                        isLoading={isSyncingCustomerData}
                    >
                    Kundendaten mit DATEV synchronisieren
                </Button>
            </Grid>
        </Grid>
    );
}

SyncCrmCustomerWithDatev.propTypes = {
    onSyncCustomerData: PropTypes.func.isRequired,
    isSyncingCustomerData: PropTypes.bool.isRequired
};

SyncCrmCustomerWithDatev.defaultProps = {
    onSyncCustomerData: () => {},
    isSyncingCustomerData: false
};

export default SyncCrmCustomerWithDatev;